function DiagnosticResult({ answers }) {

  const totalScore = answers.reduce(
    (total, answer) => total + answer.score,
    0
  );

  const maxScore = 10 * 4;

  const percentage = Math.round(
    (totalScore / maxScore) * 100
  );

  let level;
  let title;
  let description;

  if (percentage <= 40) {

    level = "Inicial";

    title = "Tu empresa tiene una gran oportunidad de organización";

    description =
      "Quizas sientas que el tiempo no te alcanze, hay procesos que actualmente dependen demasiado de tareas manuales, información dispersa o conocimiento de determinadas personas. Antes de crecer, ordenar estos procesos puede generar un impacto importante.";

  } else if (percentage <= 70) {

    level = "En evolución";

    title = "Tu empresa está creciendo, pero todavía hay procesos para ordenar";

    description =
      "Tu empresa esta bastante bien, ya contás con algunas herramientas y procesos organizados, pero todavía existen tareas manuales o información que podría centralizarse y automatizarse.";

  } else {

    level = "Preparada para crecer";

    title = "Tu empresa tiene una buena base para dar el próximo paso";

    description =
      "Tenés procesos y herramientas que permiten tomar mejores decisiones. El siguiente paso puede estar en automatizar, integrar información y eliminar tareas que todavía consumen tiempo.";

  }

  return (
    <section className="result-section">

      <div className="result-card">

        <span className="diagnostic-label">
          DIAGNÓSTICO COMPLETADO
        </span>

        <div className="result-circle">

          <strong>{percentage}%</strong>

          <span>
            nivel de
            <br />
            preparación
          </span>

        </div>

        <div className="result-level">
          {level}
        </div>

        <h1>{title}</h1>

        <p>{description}</p>

        <div className="result-message">

          <strong>
            ¿Querés descubrir dónde estás perdiendo tiempo?
          </strong>

          <span>
            Podemos analizar tus procesos, datos y herramientas
            actuales para detectar oportunidades concretas de
            organización y automatización.
          </span>

        </div>
        <button
          className="contact-button"
          onClick={() =>
            window.open(
              "https://wa.me/5492954396316?text=" +
                encodeURIComponent("Hola, quiero analizar cómo puedo reordenar los procesos y datos de mi empresa."),
              "_blank"
            )
          }
        >
          QUIERO ANALIZAR MI PROCESO
        </button>

      </div>

    </section>
  );
}

export default DiagnosticResult;